import * as React from 'react';
import classnames from 'classnames';

type Props = {
  children: React.ReactNode,
  isVisible: boolean
};

const DeliverableTabWrapper = (
  {
    children,
    isVisible
  }: Props
): JSX.Element => {
  const classes = classnames('deliverable__tab', {
    'deliverable__tab--hidden': !isVisible
  });

  return (
    <div className={classes}>
      {children}
    </div>
  );
};

export default DeliverableTabWrapper;
